<template>
    <div>
        <template v-if="loaded">
            <rkm-alert
                v-if="form.hasInventarioNaoFinalizado"
                color="warning"
            >
                Existem contagens não finalizadas.
            </rkm-alert>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.grupos"
                        default-option-text="Todos"
                        label="Grupo"
                        show-default-option
                        textField="nome"
                        v-model="form.grupoId"
                        valueField="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :disabled="!form.grupoId"
                        :options="subgrupos"
                        default-option-text="Todos"
                        label="Subgrupo"
                        show-default-option
                        textField="nome"
                        v-model="form.subgrupoId"
                        valueField="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.ModalNovoLote.open()"
                        color="primary"
                    >
                        Adicionar novo lote
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <rkm-area
                no-margin-top
                title="Materiais"
            >
                <template v-slot:trailing>
                    <rkm-button
                        :disabled="items.length === 0"
                        @click="handlePrint()"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="itemsNotDeleted"
                    :tbody-tr-class="rowClass"
                    :sort-by="sortBy"
                    @sort-changed="handleSortChanged"
                >
                    <template v-slot:cell(codigoMaterial)="data" >
                        <template v-if="sortBy === 'descricao'">
                           <span v-if="data.item.rowspan === 0">||</span>
                           <span v-else>{{ data.value || '-' }}</span>
                        </template>
                       <template v-else>{{ data.value || '-' }}</template>
                    </template>

                    <template v-slot:cell(descricao)="data" >
                        <template v-if="sortBy === 'descricao'">
                           <span v-if="data.item.rowspan === 0">||</span>
                           <span v-else>{{ data.value || '-' }}</span>
                        </template>
                       <template v-else>{{ data.value || '-' }}</template>
                    </template>

                    <template v-slot:cell(lote)="{ item }">
                        <span :class="{ red: item.aVencerOuVencido }">{{ item.lote || '-' }}</span>
                    </template>

                    <template v-slot:cell(validadeLote)="{ item }">
                        <span :class="{ red: item.aVencerOuVencido }">{{ item.validadeLote || '-' }}</span>
                    </template>

                    <template v-slot:cell(subgrupo)="{ value }">
                        {{ value || '-' }}
                    </template>

                    <template v-slot:cell(isAtivo)="{ item }">
                        {{ item.isAtivo ? 'ATIVO' : 'INATIVO' }}
                    </template>

                    <template v-slot:cell(contagem)="{ item }">
                        <rkm-form-input
                            number
                            v-model="item.contagem"
                            :validations="validations.contagem"
                            class="my-auto contagem"
                        />
                    </template>

                    <template v-slot:cell(divergencia)="{ item }">
                        <template v-if="!isNaN(parseInt(item.contagem))">
                            <span
                                :class="{
                                    red: getDivergencia(item.estoque, item.contagem) < 0,
                                    blue: getDivergencia(item.estoque, item.contagem) > 0
                                }
                            ">
                                {{ getDivergencia(item.estoque, item.contagem) }}
                            </span>
                        </template>
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            v-if="item.isNovoLote"
                            @click="handleExcluirLote(item)"
                            color="danger"
                            small
                            title="Excluir lote"
                        >
                            <rkm-icon icon="times" />
                        </rkm-button>
                    </template>

                    <template #afterPagination>
                        <div class="mt-2">
                            <rkm-row>
                                <rkm-col>
                                    <p>O lote e a validade em <span class="red">vermelho</span> representam que o prazo de validade do material é menor que 90 dias ou está vencido.</p>
                                </rkm-col>
                            </rkm-row>
                        </div>
                    </template>
                </rkm-table>
            </rkm-area>

            <ModalNovoLote
                :data="{
                    dataAtual: additionals.dataAtual,
                    grupo: grupoSelected,
                    subgrupo: subgrupoSelected
                }"
                @save="addLote"
                ref="ModalNovoLote"
            />
        </template>
    </div>
</template>

<script>
// Components
import ModalNovoLote from './components/material/Modal'

// Mixins.
import { repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalNovoLote },
    created() {

        this.repositories = {
            inventario: this.getConectaSusRepository('almoxarifado.inventario'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
        }

        this.load()
    },
    computed: {
        itemsNotDeleted() {

            return this.items.filter(i => !i.deleted)
        },
        grupoSelected() {

            if (this.form.grupoId) {

                return this.form.grupos.find(g => g.id === this.form.grupoId)
            }

            return null
        },
        subgrupoSelected() {

            if (this.form.subgrupoId) {

                return this.subgrupos.find(g => g.id === this.form.subgrupoId)
            }

            return null
        },
        requestParams() {

            const params = {}

            if (this.form.grupoId) {

                params.grupo_id = this.form.grupoId
            }

            if (this.form.subgrupoId) {

                params.subgrupo_id = this.form.subgrupoId
            }

            return params
        },
        subgrupos() {

            if (this.form.grupoId) {

                return this.form.grupos.find(g => g.id === this.form.grupoId).subgrupos
            }

            return []
        },
        fields() {

            const fields = [
                {
                    name: 'cadastroMaterial.codigoMaterial',
                    key: 'codigoMaterial',
                    label: 'Código',
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    name: 'cadastroMaterial.descricao',
                    key: 'descricao',
                    label: 'Descrição',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'almoxarifadoEntradaItem.lote',
                    key: 'lote',
                    label: 'Lote',
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    name: 'almoxarifadoEntradaItem.validadeLote',
                    key: 'validadeLote',
                    label: 'Validade',
                    class: 'col-min text-center',
                    sortable: true
                }
            ]

            if (!this.form.grupoId) {

                fields.push({
                    name: 'cadastroGrupo.nome',
                    key: 'grupo',
                    label: 'Grupo',
                    sortable: true
                })
            }

            if (!this.form.subgrupoId) {

                fields.push({
                    name: 'cadastroSubgrupo.nome',
                    key: 'subgrupo',
                    label: 'Subgrupo',
                    sortable: true
                })
            }

            fields.push({
                name: 'cadastroMaterial.isAtivo',
                key: 'isAtivo',
                label: 'Status',
                class: 'col-min text-center',
                sortable: true
            })

            fields.push({
                name: 'estoque',
                key: 'estoque',
                label: 'Estoque',
                class: 'col-min text-center'
            })

            fields.push({
                key: 'contagem',
                label: 'Contagem',
                class: 'col-min text-center'
            })

            fields.push({
                key: 'divergencia',
                label: 'Divergência',
                class: 'col-min text-center'
            })

            if (this.items.find(i => i.isNovoLote)) {

                fields.push({
                    key: 'actions',
                    label: '',
                    class: 'col-min text-center'
                })
            }

            const sortedItems = this.items.slice().sort((a, b) => {
                return a.descricao.localeCompare(b.descricao);
            });

            const groupedItems = sortedItems.reduce((acc, item) => {
                const key = item.descricao;
                acc[key] = acc[key] || [];
                acc[key].push(item);
                return acc;
            }, {});

            Object.values(groupedItems).forEach(group => {
                const rowCount = group.length;
                group.forEach((item, index) => {
                    item.rowspan = index === 0 ? rowCount : 0;
                });
            });

            return fields
        },
        validations() {

            return {
                contagem: {
                    max: 8
                }
            }
        }
    },
    data: () => ({
        sortBy: 'descricao',
        additionals: null,
        form: null,
        loaded: false,
        items: [],
        itemsTouched: false,
        unwatchers: {
            formGrupoId: null,
            formSubgrupoId: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleSortChanged(newSortBy) {
            this.sortBy = newSortBy.sortBy;
        },
        getDivergencia(estoque, contagem) {

            return parseInt(contagem) - parseInt(estoque)
        },
        addLote(material) {

            if (this.hasItemComLoteIncluso(material)) {

                this.showValidationNotification('Material com o mesmo lote já incluso.')

                return;
            }

            material.saved = false

            this.items.push(material)
            this.$refs.ModalNovoLote.close()
        },
        hasItemComLoteIncluso(material) {

            return !!this.itemsNotDeleted.find(i => i.id === material.id && i.lote === material.lote)
        },
        handleExcluirLote(item) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o lote?',
                async () => item.deleted = true
            )
        },
        load() {

            this.setLoading()

            this.repositories.inventario.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.loaded = true

                    this.addWatchers()
                    this.search()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.addFormGrupoIdWatcher()
            this.addFormSubgrupoIdWatcher()
        },
        addFormGrupoIdWatcher() {

            this.unwatchers.formGrupoId = this.$watch('form.grupoId', function (idNew, idOld) {

                const search = async () => {

                    if (this.form.subgrupoId) {

                        this.unwatchers.formSubgrupoId()
                        this.form.subgrupoId = null
                        this.addFormSubgrupoIdWatcher()
                    }

                    this.search()
                }

                if (!this.itemsTouched || idNew === idOld) {

                    search()
                }
                else {

                    this.showConfirmation(
                        'As contagens e os novos lotes não salvos serão perdidos. Deseja realmente alterar o grupo?',
                        search,
                        async () => this.form.grupoId = idOld,
                    )
                }
            })
        },
        addFormSubgrupoIdWatcher() {

            this.unwatchers.formSubgrupoId = this.$watch('form.subgrupoId', function (idNew, idOld) {

                if (!this.itemsTouched || idNew === idOld) {

                    this.search()
                }
                else {

                    this.showConfirmation(
                        'As contagens e os novos lotes não salvos serão perdidos. Deseja realmente alterar o subgrupo?',
                        async () => this.search(),
                        async () => this.form.subgrupoId = idOld,
                    )
                }
            })
        },
        search() {

            this.setLoading()

            this.repositories.inventario.index(this.requestParams)
                .then(({ data }) => {

                    this.items = data.map(item => {

                        item.deleted = false
                        item.saved = true

                        return item
                    })

                    this.$nextTick().then(() => this.itemsTouched = false)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        finalizar() {

            this.save(true)
        },
        save(finalizar = false) {

            this.setLoading()

            this.repositories.inventario.store(this.prepareData(finalizar))
                .then(() => {

                    this.showSaveNotification()
                    this.$emit('save')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData(finalizar) {

            const data = {
                finalizar,
                itens: this.items.map(i => ({
                    materialId: i.id,
                    materialBnafarId: i.materialBnafarId,
                    integracaoBnafarMedicamentoId: i.integracaoBnafarMedicamentoId,
                    lote: i.lote,
                    validadeLote: i.validadeLote,
                    contagem: i.contagem,
                    fabricanteId: i.fabricanteId,
                    codigoBarras: i.codigoBarras,
                    isNovoLote: !!i.isNovoLote,
                    deleted: i.deleted,
                }))
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.isNovoLote) {

                return 'table-success'
            }
        },
        handlePrint() {

            if (!this.itemsTouched) {

                this.print()

                return
            }

            this.showConfirmation(
                'As contagens e os novos lotes não salvos não serão impressos. Deseja continuar?',
                async () => this.print(),
            )
        },
        print() {

            this.setLoading()

            this.repositories.impressao.inventario(this.requestParams)
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [ repository, stringCase ],
    watch: {
        items: {
            deep: true,
            handler(items) {

                this.itemsTouched = true

                this.$emit('count-change', items.length)
            }
        },
    }
}
</script>

<style scoped>
.contagem { min-width: 120px; }
.red { color: red ;}
.blue { color: blue; }
</style>